import { InternalComment, InternalCommentOverview } from '../../types/internal-comment';

export function getThreadContext(comment: InternalCommentOverview | InternalComment): { url: string; label: string } | undefined {
    const url = location.pathname;
    if (comment.worksheet) {
        if (comment.worksheet.hasAccount) {
            return {
                label: comment.worksheet.name,
                url: url.replace(/internal-comments|dashboard/, `trial-balance/${comment.worksheet.id}`),
            };
        }
        return {
            label: comment.worksheet.name,
            url: url.replace(/internal-comments|dashboard/, `other-schedules/${comment.worksheet.id}`),
        };
    }

    return undefined;
}
